// extracted by mini-css-extract-plugin
export default {"modalOverlay":"fQ-z","modalContent":"gQ-z","header":"hQ-z","close":"iQ-z"};